// src/components/ScrollToTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
	hash.indexOf("clinical") < 0 ? window.scrollTo(0, 0) : document.getElementById('clinical-trials').scrollIntoView();
  }, [pathname, hash]);

  return null;
}